// Libs
import _indexOf from 'lodash/indexOf'

// Constants
import {
  PROP_ROLES,
} from '../constants'

// Exports
export default (role, options = {}) => (user) => {
  const roles = user[PROP_ROLES]

  if (roles == null && options.isUndefined != null) {
    return options.isUndefined
  }

  return _indexOf(user[PROP_ROLES], role) >= 0
}
